export class KeyValuePair {
  constructor(key: string, value: any) {
    this.key = key;
    this.value = value;
  }

  key: string;
  value: any;

  public stringify(): string {
    const jsonVal = JSON.stringify(this.value);
    /*const kvA = this.value as KeyValuePair[];
if (kvA) {
  const retArr = [];
  for (let i = 0; i < kvA.length; i++) {
    retArr.push(kvA[i].stringify);
  }
} else {
  const kv = this.value as KeyValuePair;
  if (kv) {
    jsonVal = kv.stringify();
  }
}*/
    return JSON.stringify({
      key: this.key,
      value: jsonVal,
    });
  }
}
